import { createStyles, makeStyles } from '@material-ui/core';

export const ASPECT_MEDIA = '@media (max-aspect-ratio: 15/6) ';

const BASE_IMAGE_DESKTOP_WIDTH = 2878,
    BASE_IMAGE_DESKTOP_HEIGHT = 1440,
    BASE_IMAGE_MOBILE_WIDTH = 1125,
    BASE_IMAGE_MOBILE_HEIGHT = 1500,
    BASE_IMAGE_DESKTOP_TEXT_TOP = 116,
    BASE_IMAGE_DESKTOP_TEXT_LEFT = 740,
    BASE_IMAGE_DESK_LINEH = 128,
    BASE_IMAGE_MOBILE_TEXT_TOP = 70,
    BASE_IMAGE_MOBILE_TEXT_LEFT = 120,
    BASE_IMAGE_MOBILE_LINEH = 81;

export const MOBILE_WIDTH = 100,
    MOBILE_HEIGHT = (8 / 6) * MOBILE_WIDTH,
    DESKTOP_HEIGHT = 85,
    MAX_DESKTOP_HEIGHT = 800,
    DESKTOP_WIDTH = DESKTOP_HEIGHT * 2,
    MAX_DESKTOP_WIDTH = MAX_DESKTOP_HEIGHT * 2,
    SMALL_DESKTOP_WIDTH = 100,
    SMALL_DESKTOP_HEIGHT = SMALL_DESKTOP_WIDTH / 2,
    DESK_LINE_H = (BASE_IMAGE_DESK_LINEH / BASE_IMAGE_DESKTOP_HEIGHT) * DESKTOP_HEIGHT,
    SMALL_DESK_LINE_H = (BASE_IMAGE_DESK_LINEH / BASE_IMAGE_DESKTOP_HEIGHT) * SMALL_DESKTOP_HEIGHT,
    MOBILE_LINE_H = (BASE_IMAGE_MOBILE_LINEH / BASE_IMAGE_MOBILE_HEIGHT) * MOBILE_HEIGHT;

const ON_VIDEO_TEXT_TOP = `${
    (BASE_IMAGE_DESKTOP_TEXT_TOP / BASE_IMAGE_DESKTOP_HEIGHT) * DESKTOP_HEIGHT
}vh`;
const ON_VIDEO_TEXT_LEFT = `calc(${
    (BASE_IMAGE_DESKTOP_TEXT_LEFT / BASE_IMAGE_DESKTOP_WIDTH) * DESKTOP_WIDTH
}vh + 50vw - ${DESKTOP_HEIGHT}vh)`;

const ON_VIDEO_TEXT_ASPECT_TOP = `${
    (BASE_IMAGE_DESKTOP_TEXT_TOP / BASE_IMAGE_DESKTOP_HEIGHT) * SMALL_DESKTOP_HEIGHT
}vw`;
const ON_VIDEO_TEXT_ASPECT_LEFT = `${
    (BASE_IMAGE_DESKTOP_TEXT_LEFT / BASE_IMAGE_DESKTOP_WIDTH) * SMALL_DESKTOP_WIDTH
}vw`;

const ON_VIDEO_TEXT_XS_TOP = `${
    (BASE_IMAGE_MOBILE_TEXT_TOP / BASE_IMAGE_MOBILE_HEIGHT) * MOBILE_HEIGHT
}vw`;
const ON_VIDEO_TEXT_XS_LEFT = `${
    (BASE_IMAGE_MOBILE_TEXT_LEFT / BASE_IMAGE_MOBILE_WIDTH) * MOBILE_WIDTH
}vw`;

export const useIndexStyles = makeStyles((theme: any) =>
    createStyles({
        outerContainer: {
            height: theme.sizes.pageHeight,
            overflow: 'hidden'
        },
        innerContainer: {
            transition: 'all 600ms ease'
        },
        footerWrapper: { maxHeight: '100vh', overflow: 'auto' },
        scrollContainer: {
            height: theme.sizes.pageHeight,
            overflow: 'auto',
            '&::-webkit-scrollbar-track': {
                // Scrollbar track
                background: '#ccc',
                borderRadius: '2px',
                zIndex: 1000
            },
            '&::-webkit-scrollbar': {
                // General scrollbar
                width: '10px',
                height: '10px',
                zIndex: 1000
            }
        },
        page2Content: {
            position: 'relative',
            height: theme.sizes.pageHeight,
            // backgroundColor: '#000',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            zIndex: 2,
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'flex-end'
            }
        },
        page1Content: {
            position: 'relative',
            height: theme.sizes.pageHeight,
            // backgroundColor: '#000',
            display: 'grid',
            gridAutoColumns: '1fr',
            gridAutoRows: '1fr auto',
            zIndex: 2
        },

        eventContainer: {
            position: 'relative',
            width: '90%',
            cursor: 'grab',
            margin: theme.spacing(4),
            display: 'flex',
            alignSelf: 'flex-end',
            justifyContent: 'flex-end'
        },

        videoContainer: {
            height: `${DESKTOP_HEIGHT}vh`,
            width: '100%',
            margin: 'auto',
            position: 'relative'
            // [ASPECT_MEDIA]: {
            //     height: `${MOBILE_WIDTH / 2}vw`,
            //     width: `${MOBILE_WIDTH}vw`
            // }
        }
    })
);

export const useHomeSubStyles = makeStyles((theme) =>
    createStyles({
        greenText: { color: theme.palette.primary.dark },

        text: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            lineHeight: `${DESK_LINE_H}vh`,
            [ASPECT_MEDIA]: {
                lineHeight: `${SMALL_DESK_LINE_H}vw`
            },
            [theme.breakpoints.down('xs')]: {
                lineHeight: `${MOBILE_LINE_H}vw`
            }
        },
        p2Text: {
            textShadow: ` 3px 3px 5px #444,
                -2px 1px 1px #444`,
            color: '#ddd',
            [theme.breakpoints.down('xs')]: {
                // display: 'none'
            }
            // backgroundColor: `#FFFFFF44`
        },
        title: {
            fontSize: `${DESK_LINE_H * 0.83}vh`,
            [ASPECT_MEDIA]: {
                fontSize: `${SMALL_DESK_LINE_H * 0.83}vw`
            },
            [theme.breakpoints.down('xs')]: {
                fontSize: `${MOBILE_LINE_H * 0.83}vw`
            }
        },
        subtitle: {
            fontSize: `${DESK_LINE_H * 0.55}vh`,
            [ASPECT_MEDIA]: {
                fontSize: `${SMALL_DESK_LINE_H * 0.55}vw`
            },
            [theme.breakpoints.down('xs')]: {
                fontSize: `${MOBILE_LINE_H * 0.55}vw`
            }
        },

        onVideoContent: {
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',

            top: ON_VIDEO_TEXT_TOP,
            left: ON_VIDEO_TEXT_LEFT,
            [ASPECT_MEDIA]: {
                top: ON_VIDEO_TEXT_ASPECT_TOP,
                left: ON_VIDEO_TEXT_ASPECT_LEFT
            },
            [theme.breakpoints.down('xs')]: {
                top: ON_VIDEO_TEXT_XS_TOP,
                left: ON_VIDEO_TEXT_XS_LEFT
            }
        },

        button: {
            margin: 'auto',
            marginTop: '1em',
            marginBottom: '3em',
            [theme.breakpoints.down('xs')]: {
                marginBottom: '1em'
            }
        },
        videoPlaceholder: {
            height: `${DESKTOP_HEIGHT}vh`,

            [ASPECT_MEDIA]: { height: `${SMALL_DESKTOP_HEIGHT}vw` },
            [theme.breakpoints.down('xs')]: { height: 0 }
        },
        p2wrapper: {
            width: '100%',
            backdropFilter: 'saturate(180%) blur(10px)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        p2Description: {
            zIndex: 20,
            width: '65%',
            placeSelf: 'center',
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: theme.spacing(3),
            flex: 1,

            justifyContent: 'center',
            [ASPECT_MEDIA]: { width: '85%' },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
                justifyContent: 'flex-end'
            }
        },
        hide: { display: 'none' }
    })
);

export const useHomeVideoStyles = makeStyles((theme) => ({
    video: {
        height: `${DESKTOP_HEIGHT}vh`,
        width: `${DESKTOP_WIDTH}vh`,

        margin: 'auto',
        right: 0,
        left: 0,
        position: 'absolute',
        [ASPECT_MEDIA]: {
            height: `calc(${SMALL_DESKTOP_HEIGHT}vw - 10px)`,
            width: `calc(${SMALL_DESKTOP_WIDTH}vw - 10px)`
        },
        [theme.breakpoints.down('xs')]: {
            height: `${MOBILE_HEIGHT}vw`,
            width: `${MOBILE_WIDTH}vw`
        }
    },
    hide: {
        width: 0,
        height: 0,
        visibility: 'hidden',
        position: 'absolute'
    }
}));

export const useFloatConsultantStyles = makeStyles((theme) => ({
    container: {
        position: 'absolute',
        top: ON_VIDEO_TEXT_TOP,
        right: 10,
        display: 'flex',
        zIndex: 999
    },
    inputContainer: {},
    emailField: {
        // backgroundColor: '#000',
        border: '1px solid',
        borderColor: (theme.palette.primary as any)['700'],
        borderRadius: '99em',
        display: 'flex',
        [theme.breakpoints.down('xs')]: {
            borderColor: 'transparent'
        }
    },
    formButton: {
        padding: '0 4px',
        [theme.breakpoints.down('xs')]: {
            borderRadius: 4
        }
    },
    textInput: {
        padding: '4px 12px'
    },
    input: {
        transition: 'width 0.3s ease-in-out',
        width: '14ch',
        '&:focus': {
            width: '25ch'
        },
        [theme.breakpoints.down('xs')]: {
            width: '0',

            '&:focus': {
                width: '0'
            }
        }
    }
}));
